import React from 'react';
import {Box, styled} from '@mui/material';
import {designSystemToken, Icon, Input} from '@lightricks/react-design-system';

const StyledInput = styled(Input)(() => ({
  'width': '100%',
  'fontFamily': 'Brown LL',
  'fontSize': '20px !important',
  'lineHeight': '26px',
  'flex': 1,
  'boxSizing': 'border-box',
  '& .MuiInputBase-root': {
    padding: '24px !important',
    borderRadius: '24px !important',
    border: `1px solid ${designSystemToken('semantic.bg.neutral-secondary')}`,
    background: designSystemToken('semantic.bg.secondary'),
    height: '74px !important',
    marginBottom: '0 !important',
  },
  '& .MuiInputBase-input': {
    padding: '24px 0 !important',
    fontSize: '20px !important',
    fontWeight: '700 !important',
  },
  '& .MuiFormLabel-root, & .MuiInputLabel-root': {
    marginBottom: '0 !important',
  },
}));

type RenameProjectProps = {
  testID?: string;
  projectNamePlaceholder?: string;
  projectName?: string;
  projectNameChange: (projectName: string) => void;
  onBlur?: (name: string) => void;
};

function RenameProject({
  testID = 'rename-project',
  projectNamePlaceholder,
  projectName,
  projectNameChange,
  onBlur,
}: RenameProjectProps) {
  return (
    <Box>
      <StyledInput
        data-testid={testID}
        onInputChange={projectNameChange}
        placeholder={projectNamePlaceholder || ''}
        inputProps={{
          'aria-label': 'Project name',
          'data-testid': 'rename-project-input',
          'value': projectName ?? '',
          'onBlur': (event: React.FocusEvent<HTMLInputElement>) =>
            onBlur?.(event.target.value),
        }}
        endIcon={
          <Icon name="Navigation-Edit" size="medium" appearance="black" />
        }
      />
    </Box>
  );
}

export default RenameProject;
